import * as MSAL from '@azure/msal-browser'
import config from '../config.js'
export default new MSAL.PublicClientApplication(config.msal)
